import date from "@wielink-application/shared/js/mixins/date.js";
export default date;